module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f0741d_banner_800x600.e3a15a55.png";